import { ProductDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useMemo, useState } from 'react';
import { getProductDoc } from 'src/utils/firebase/firebase-short-cut';
import useSWR, { mutate } from 'swr';

const getProrducts = async (joinedIds: string) => {
  const ids = joinedIds.replace('products', '').split('.');
  const promises = ids.map((id) => getProductDoc(id));
  const data = await Promise.all(promises);
  return data?.filter((product) => product !== undefined);
};

const useProductsByIds = (ids?: ProductDoc['_id'][]) => {
  const [initialDataFetched, setInitialDataFetched] = useState(false);

  const joinedIds = ids?.join('.');
  const memoizedIds = useMemo(() => joinedIds, [joinedIds]);
  const {
    data,
    isLoading: productsLoading,
    error,
  } = useSWR(ids && ids.length > 0 ? 'products' + memoizedIds : null, getProrducts, {
    revalidateOnMount: false,
    errorRetryCount: 2,
  });
  const products = useMemo(
    () => (data ? (data as ProductDoc[]).filter((product) => product !== undefined) : []),
    [data]
  );

  useEffect(() => {
    if (!error && !data && memoizedIds && memoizedIds && !initialDataFetched) {
      mutate('products' + memoizedIds);
      setInitialDataFetched(true);
    }
  }, [data, error, initialDataFetched, memoizedIds, productsLoading]);

  return {
    products,
    productsLoading,
    productsError: error,
  };
};

export default useProductsByIds;
